export {};

interface EpiFormsGlobal {
  EPiServer?: {
    Forms?: {
      Validators?: Record<string, unknown>;
    };
  };
}

declare global {
  interface Window {
    turnstile?: {
      reset: (container: Element) => void;
    };
  }
  var epi: EpiFormsGlobal | undefined;
}

const VALIDATOR_KEY = 'SKAGEN.Business.Turnstile.TurnstileValidator';

function registerValidator() {
  if (typeof epi === 'undefined' || !epi?.EPiServer?.Forms?.Validators) return;

  if (epi.EPiServer.Forms.Validators[VALIDATOR_KEY]) return;

  epi.EPiServer.Forms.Validators[VALIDATOR_KEY] = {
    validate(_fieldName: string, fieldValue: string) {
      return !!fieldValue;
    },
    onServerValidateFailed($element: { find: (s: string) => Element[] }) {
      if (window.turnstile) {
        const containers = $element.find('.cf-turnstile');
        if (containers.length) {
          window.turnstile.reset(containers[0]);
        }
      }
    },
  };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerValidator);
} else {
  registerValidator();
}
